module.exports = __webpack_public_path__ + "img/dashjs.80c6bbd6.png";